module.exports = __webpack_public_path__ + "static/media/fr-timothy.57cc653d.jpg";